import { NgZone } from '@angular/core';
import { FirebaseApp, FirebaseOptions } from '@angular/fire';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireMessaging } from '@angular/fire/messaging';

export class AOFirebaseConnectionService {

  private _configs: FirebaseOptions = {};

  private _auth: AngularFireAuth;

  private _database: AngularFireDatabase;

  private _firestore: AngularFirestore;

  private _messaging: AngularFireMessaging;

  private _storage: AngularFireStorage;

  constructor(
    protected _name: string,
    protected _hash: string,
    protected _app: FirebaseApp,
    protected _zone: NgZone
  ) {
  }

  app(): FirebaseApp {
    return this._app;
  }

  name() {
    return this._name;
  }

  hash() {
    return this._hash;
  }

  // -------------------------------------------------------------------------------------------------------------------

  auth(): AngularFireAuth {
    return this._auth
      ? this._auth
      : this._auth = new AngularFireAuth(this._configs, this._name, null, this._zone);
  }

  database(): AngularFireDatabase {
    return this._database
      ? this._database
      : this._database = new AngularFireDatabase(this._configs, this._name, null, null, this._zone);
  }

  firestore(): AngularFirestore {
    return this._firestore
      ? this._firestore
      : this._firestore = new AngularFirestore(this._configs, this._name, null, null, null, this._zone, null);
  }

  messaging(): AngularFireMessaging {
    return this._messaging
      ? this._messaging
      : this._messaging = new AngularFireMessaging(this._configs, this._name, null, this._zone);
  }

  storage(): AngularFireStorage {
    return this._storage
      ? this._storage
      : this._storage = new AngularFireStorage(this._configs, this._name, null, null, this._zone);
  }

  // -------------------------------------------------------------------------------------------------------------------

  async logout(): Promise<boolean> {
    if (this._auth) {
      try {
        await this._auth.auth.signOut();
      } catch (e) {
        console.warn('Oops! Failed to run signOut.');
      }
    }
    return Promise.resolve(true);
  }

  async destroy(): Promise<boolean> {
    await this.logout();
    await this._app.delete();
    return Promise.resolve(true);
  }

}
